import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FiDocumentTemplateItemOptionsBase } from '../document-template-item-options-base';

@Component({
    selector: 'fi-document-template-item-options-image',
    templateUrl: './document-template-item-options-image.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./document-template-item-options-image.component.scss', '../../edit-item/image/image.component.scss'],
    standalone: false,
})
export class FiDocumentTemplateItemOptionsImageComponent
    extends FiDocumentTemplateItemOptionsBase
    implements OnInit, OnDestroy
{
    ngOnInit() {
        if (!this.data.content.Value.File) this.data.content.Value.File = {};

        if (!this.data.content.Value.additionalFile) this.data.content.Value.additionalFile = {};
    }

    ngOnDestroy() {
        if (this.data.content.Value.File && !this.data.content.Value.File.Url) delete this.data.content.Value.File;

        if (this.data.content.Value.additionalFile && !this.data.content.Value.additionalFile.Url)
            delete this.data.content.Value.additionalFile;
    }

    onFileChange($event) {
        this.mediaBankFileChangedEmitter.emit($event);
    }
}
